import React from 'react';

export const UniPayIcon: React.FunctionComponent = () => (
  <svg width={100} height={50} xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h100v50H0z" />
      <path
        fill="#CC1855"
        fillRule="nonzero"
        d="M75.673 15h6.623l2.139 5.983L88.318 15h6.623l-8.43 11.44-1.204 6.022h-6.021l1.204-6.022zM67.243 15h6.02l3.013 17.462h-5.42l-.29-2.408H66.64l1.729-3.613h1.761l-.723-6.022-5.778 12.043H58.21zM52.493 18.613l-.798 4.215h2.392c1.807 0 2.49-.498 2.793-2.07.303-1.573-.667-2.145-1.994-2.145h-2.393zM47.756 15h8.471c3.58 0 6.96.889 6.048 5.716-.822 4.345-3.37 5.724-8.188 5.724H51.01l-1.138 6.022h-5.419L47.756 15zM41.042 15h4.812l-.68 3.63h-4.818zM40.147 19.817h4.79l-2.381 12.645h-4.817zM24.444 19.817h4.262l-.455 2.407a5.932 5.932 0 0 1 5.272-3.01 4.387 4.387 0 0 1 3.011 1.204c1.204 1.204 1.058 3.259.65 5.419l-1.252 6.624h-4.817l1.256-6.624c.447-2.407-1.259-2.407-1.858-2.407-1.204 0-2.042.745-2.356 2.407L26.9 32.461h-4.817l2.361-12.644zM11.846 33.064c4.81 0 8.362-1.807 9.617-8.43L23.286 15h-5.409l-1.814 9.634c-.462 2.415-1.211 4.215-3.619 4.215-2.408 0-2.195-2.166-1.808-4.215L12.46 15H7.03l-1.826 9.634c-1.264 6.681 3.626 8.43 6.642 8.43z"
      />
    </g>
  </svg>
);
UniPayIcon.displayName = 'UniPayIcon';
